import { AJUDA_SETORES } from '@mymaxx/shared';

/**
 * Marca em quais setores o item vale. Nenhum marcado = todos — o padrão mais comum,
 * e que continua valendo quando um setor novo é criado.
 */
export function SeletorSetores({
  valor,
  opcoes,
  onChange,
  rotulo = 'Setores',
}: {
  valor: string[];
  opcoes: { id: string; nome: string }[];
  onChange: (setorIds: string[]) => void;
  rotulo?: string;
}) {
  const todos = valor.length === 0;

  return (
    <fieldset>
      <legend className="text-sm font-medium">{rotulo}</legend>
      <p className="mb-2 text-xs text-neutral-500">{AJUDA_SETORES}</p>

      <div className="space-y-1">
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={todos} onChange={() => onChange([])} />
          <span className={todos ? 'font-medium' : ''}>Todos os setores</span>
        </label>

        {opcoes.map((s) => (
          <label key={s.id} className="flex items-center gap-2 pl-5 text-sm">
            <input
              type="checkbox"
              checked={valor.includes(s.id)}
              onChange={(e) =>
                onChange(e.target.checked ? [...valor, s.id] : valor.filter((id) => id !== s.id))
              }
            />
            {s.nome}
          </label>
        ))}
        {opcoes.length === 0 && (
          <p className="text-sm text-neutral-500">Cadastre um setor primeiro.</p>
        )}
      </div>
    </fieldset>
  );
}
